import { Grid, Stack } from "@mui/material";
import Title1 from "../../../components/title/title1";
import { useTranslation } from "react-i18next";
import BlogDetailsBox from "../blog-details-box";
import { useEffect, useState } from "react";
import blogsData from '../../../data/blogs/en/blogs.json';

const blogLocales = "blogs";

const BlogRecommendations = ({
    selectedId
}) => {
    const {t} = useTranslation();

    const [suggestedBlogList, setSuggestedBlogList] = useState([]);

    useEffect(() => {
        if(blogsData.length > 1){
            let indexList = [];

            for(let i = 0; i < blogsData.length; i++){
                if(i !== Number.parseFloat(selectedId) - 1) indexList.push(i);
            }

            for(let i = 0; i < indexList.length; i++){
                let temp = indexList[i];
                let randomIndex = Math.floor(Math.random() * (indexList.length - 0));

                indexList[i] = indexList[randomIndex];
                indexList[randomIndex] = temp;
            }

            if(indexList.length >= 3) setSuggestedBlogList(indexList.splice(0, 3));
            else setSuggestedBlogList(indexList);
        }
    }, [selectedId]);

    return (
        <>
            <Stack
                direction='column'
                alignItems='center'
                sx={{
                    mt: {xs: 4, md: 7.5},
                    display: suggestedBlogList.length > 0 ? 'flex' : 'none'
                }}
            >
                <Title1 title={t(`${blogLocales}.more`)} description=""/>

                <Grid
                    direction='row'
                    justifyContent='center'
                    alignItems='start'
                    container
                    spacing={{xs: 2, md: 5}}
                    width='100%'
                >
                    {
                        suggestedBlogList.map((item, index) => {
                            return <Grid
                                key={index}
                                size={{xs: 12, md: 6, lg: 4}}
                            >
                                <BlogDetailsBox 
                                    index={index}
                                    img={blogsData[item].image}
                                    title={blogsData[item].title}
                                    description={blogsData[item].description}
                                    link={`/blog/${item + 1}`}
                                />
                            </Grid>
                        })
                    }
                </Grid>
            </Stack>
        </>
    );
}

export default BlogRecommendations;